import React from 'react'
import { FormControl, FormLabel, RadioGroup as RG, FormControlLabel, Radio, makeStyles, useMediaQuery, Typography } from '@material-ui/core'
import { FieldError } from './FieldError'
import './FormFields.css'
import { Controller } from 'react-hook-form'

interface RadioGroupProps {
  control: any
  label?: string
  name: string
  error?: any
  defaultValue?: string | boolean
  rules?: any
  items: any[]
  testId?: string
  id?: string
  className?: string
  ariaLabel?: string
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ control, label = '', name, error, defaultValue, rules, items, testId, className, ariaLabel }) => {
  const classes = useStyles()
  const device = useMediaQuery('(min-width:600px)') ? 'desktop' : 'mobile'
  return (
    <>
      <FormControl className={`${className} inputField`} component="fieldset" data-test={testId}>
        <FormLabel component="legend" data-test={testId}>
          {label}
        </FormLabel>
        <Controller
          name={name}
          defaultValue={defaultValue}
          control={control}
          rules={rules}
          as={
            <RG aria-label={ariaLabel} name={name}>
              {items.map((item, index) => (
                <FormControlLabel key={item.value + index} aria-label={item.label} value={item.value} data-test={item.testId} label={
                  <Typography className={device === 'mobile' ? classes.mobRadioLabel : ''}>{item.label}</Typography>} control={<Radio />
                  } 
                />
              ))}
            </RG>
          }
        ></Controller>
      </FormControl>
      <FieldError fieldError={error} />
    </>
  )
}

const useStyles = makeStyles({
  mobRadioLabel: {
    fontSize: '14px',
    lineHeight: 1.3
  }
})
